<template>
    <div>
        <loading-screen :loading="carregando"/>

        <nav-bar/>

        <div class="container" style="padding-bottom: 3rem">
            <flow/>
            <div class="section">
                <div class="card" v-if='dados'>
                    <div class="card-content">
                        <div class="card columns" style="box-shadow: none">
                            <div class="card-image column is-two-thirds">
                                <figure class="image is-4by3">
                                    <img src="../assets/antifa_game_jam.png" alt="Placeholder image">
                                </figure>
                            </div>
                            <div class="card-content column">
                                <div class="media">
                                    <div class="media-left">
                                        <figure class="image is-48x48">
                                            <img :src="avatar(nomeJogador)"
                                                 :alt="'Foto de ' + nomeJogador">
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <p class="title is-4">{{nomeJogador}}</p>
                                        <p class="subtitle is-6">{{usernameJogador}}</p>
                                    </div>
                                </div>

                                <div class="content">
                                    <span v-html="filtroTexto(dados.postagem.texto_op)"></span>
                                    <br>
                                    <time :datetime='timestampPostagem' class='is-size-7'
                                          v-if='timestampPostagem'>{{timestampPostagem.calendar()}}
                                    </time>
                                </div>
                            </div>
                        </div>
                        <!-- respostas -->
                        <article class="media">
                            <figure class="media-left">
                                <p class="image is-64x64">
                                    <img :src="avatar(nomeNPC, true)"
                                         :alt="'Foto de ' + nomeNPC">
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="has-text-black" v-text='nomeNPC'></strong>
                                        <br>
                                        {{dados.comentario_inicial}}
                                        <br>
                                        <small>{{timestampComentarioInicial}}</small>
                                    </p>
                                </div>

                                <span v-html='thread'></span>
                            </div>
                        </article>
                        <span class="is-size-7" v-text='npcDigitando'
                              style="padding-left: 80px; margin-bottom: 10px; display: block; font-style: italic"></span>
                        <!-- end respostas -->
                        <article class="media">
                            <figure class="media-left">
                                <p class="image is-64x64">
                                    <img :src="avatar(nomeJogador)"
                                         :alt="'Foto de ' + nomeJogador">
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="field">
                                    <div class="control">
                                        <div class="textarea">
                                            <template v-if='opcoesDisponiveis'>
                                                <b>Escolha sua resposta...</b>
                                                <br/>
                                                <template v-for='(resposta, i) in opcoesDisponiveis'>
                                                    <button class="button respostaJogo"
                                                            v-on:click='selecionarResposta(resposta, i)'>
                                                        {{resposta.texto_jogador}}
                                                    </button>
                                                    <br/>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <span class="is-size-7" v-if="debug">Opções Selecionadas: {{opcoesSelecionadas}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--<footer class="footer">
            <div class="container">
                <div class="content has-text-centered">
                    <p>
                        Copyright 2019
                    </p>
                </div>
            </div>
        </footer>-->
    </div>
</template>

<!--suppress JSUnusedLocalSymbols, JSUnusedGlobalSymbols -->
<script>
    import moment from 'moment';
    import gamedata from '../assets/gamedata.json';
    import {GameData} from './GameScreen/gamedata';
    import NavBar from '../components/NavBar';
    import Flow from '@/components/Flow';
    import LoadingScreen from '@/components/LoadingScreen';

    /* TODO
        - Decidir se vai ter internetês/emojis/onde por
        - Pedir ajuda externa pra revisar esses textos?
     */

    const nomeN = [
        'Nathan',
        'Neto',
        'Nivaldo',
        'Nildo',
        'Nestor',
        'Ney',
        'Naldo',
        'Nélio',
        'Nicolino',
        'Nereu'
    ];
    const nomeP = [
        'Pereira',
        'Paes',
        'Paiva',
        'Pinheiro',
        'Peixoto',
        'Paulo',
        'Pedro',
        'Paixão',
        'Patrício',
        'Pastore'
    ];
    const nomeC = [
        'Cortez',
        'Correia',
        'Campos',
        'Camargo',
        'Cardoso',
        'Carvalho',
        'Castro',
        'Cerqueira',
        'Chagas',
        'Cipriano'
    ];

    export default {
        name: 'GameScreen',
        components: {Flow, NavBar, LoadingScreen},
        data() {
            return {
                carregando: false,
                thread: '',
                opcoesDisponiveis: '',
                opcoesSelecionadas: '',
                npcDigitando: '',
                timestampPostagem: '',
                timestampComentarioInicial: '',
                dados: '',
                debug: process.env.NODE_ENV === 'development',
                nomeNPC: '',
            }
        },
        computed: {
            nomeJogador: function () {
                return this.$store.state.SaveState.nomeJogador;
            },

            usernameJogador: function () {
                return '@' + this.nomeJogador.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w]/gi, '').toLowerCase();
            },

            online: function () {
                return this.$store.state.online;
            }
        },
        created() {
            this.dados = new GameData();
        },
        methods: {
            avatar: function(nome, npc) {
                // if (this.online) {
                    // return 'https://api.adorable.io/avatars/124/' + nome
                // } else {
                    if (npc) return require('../assets/npc.png');
                    return require('../assets/jogador.png');
                // }
            },

            iniciar: function () {
                this.carregarDados().then(() => {
                    this.opcoesDisponiveis = this.dados.respostas;
                    this.timestampComentarioInicial = new moment().fromNow();
                });
                this.timestampPostagem = new moment().subtract(20, 'minutes');
                this.nomeNPC = `${nomeN[Math.floor(Math.random() * nomeN.length)]} ${nomeP[Math.floor(Math.random() * nomeP.length)]} ${nomeC[Math.floor(Math.random() * nomeC.length)]}`
            },
            recomecar: function () {
                this.carregando = true;
                setTimeout(() => {
                    this.thread = '';
                    this.opcoesDisponiveis = '';
                    this.opcoesSelecionadas = '';
                    this.npcDigitando = '';
                    this.timestampPostagem = '';
                    this.timestampComentarioInicial = '';
                    this.dados = new GameData();
                    this.iniciar();
                }, 1000);
                setTimeout(() => {
                    this.carregando = false;
                }, 3000)
            },
            carregarDados: async function () {
                this.dados = gamedata;
            },
            filtroTexto: function (texto) {
                return texto.replace(new RegExp(/(#[A-Za-z0-9-_]+)(?:#[A-Za-z0-9-_]+)*/g), match => {
                    return '<a target="_blank" href="https://itch.io/jam/antifa-game-jam"><span class="hashtag">' + match + '</span></a>';
                });
            },

            selecionarResposta: function (resposta, i) {
                this.opcoesDisponiveis = '';
                this.jogador(resposta.texto_jogador);
                this.opcoesSelecionadas += (i + 1);
                if (resposta.texto_npc) {
                    this.npc(resposta.texto_npc).then(() => {
                        if (resposta.respostas) {
                            this.opcoesDisponiveis = resposta.respostas;
                        }
                    });
                } else if (resposta.mensagem_final) {
                    this.$store.commit('setMensagemFinal', resposta.mensagem_final);
                    this.$router.push({
                        name: 'EndingScreen'
                    })
                }
            },
            npc: function (texto) {
                this.npcDigitando = `${this.nomeNPC} está digitando...`;
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.thread += this.templateResposta(texto, true);
                        this.npcDigitando = '';
                        resolve();
                    }, 3000)
                });
            },
            jogador: function (texto) {
                this.thread += this.templateResposta(texto, false);
            },

            templateResposta: function (texto, npc) {
                return `
            <article class="media">
                <figure class="media-left">
                    <p class="image is-48x48">
                        <img alt="Foto de ${npc ? this.nomeNPC : this.nomeJogador}"
                             src="${this.avatar(npc ? this.nomeNPC : this.nomeJogador, npc)}">
                    </p>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <p>
                            <strong class="has-text-black">${npc ? this.nomeNPC : this.nomeJogador}</strong>
                            <br>
                            ${texto}
                            <br>
                            <small>${new moment().fromNow()}</small>
                        </p>
                    </div>
                </div>
            </article>
            `;
            }
        },
        mounted() {
            moment.locale('pt-br');
            if (!this.nomeJogador) {
                this.$router.push({
                    name: 'MainScreen'
                });
            }
            this.iniciar();
        }
    }
</script>

<!--suppress CssUnusedSymbol, CssUnknownProperty -->
<style scoped>
    >>> .hashtag {
        color: #3789f4;
        cursor: pointer;
    }

    >>> .hashtag:hover {
        text-decoration: underline;
    }

    div.textarea {
        height: auto;
    }

    .card {
        overflow: hidden
    }

    .card.large {
        height: 600px;
        -webkit-backface-visibility: hidden;
        backface-visibility: initial;
        border-radius: 5px;
    }

    .media-content {
        overflow: hidden;
    }

    .title.no-padding {
        margin-bottom: 0 !important;
    }

    .footer {
        background-color: #222831;
        color: lemonchiffon;
    }

    .footer p,
    strong {
        color: lemonchiffon
    }

    .footer a:hover {
        color: crimson;
    }

    .fa {
        color: lemonchiffon;
        margin: 10px
    }

    .button.respostaJogo {
        margin-bottom: 5px;
        height: auto;
        white-space: normal;
        text-align: left;
    }

    .button.respostaJogo:hover {
        background: #b7cef4;
    }
</style>